module.exports = __webpack_public_path__ + "img/¥0.15.e4c9710d.png";